"use client";

import { Button } from "@heroui/react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

import { MoonFilledIcon, SunFilledIcon } from "@/components/icons";

export interface ThemeSwitchProps {
  className?: string;
}

export const ThemeSwitch = ({ className }: ThemeSwitchProps) => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button
        aria-label="Theme switch"
        className={`tap-highlight-transparent ${className ?? ""}`}
        isIconOnly
        variant="ghost"
      >
        <SunFilledIcon size={22} />
      </Button>
    );
  }

  const isLight = theme === "light";

  return (
    <Button
      aria-label={`Switch to ${isLight ? "dark" : "light"} mode`}
      className={`tap-highlight-transparent ${className ?? ""}`}
      isIconOnly
      onPress={() => setTheme(isLight ? "dark" : "light")}
      variant="ghost"
    >
      {isLight ? <SunFilledIcon size={22} /> : <MoonFilledIcon size={22} />}
    </Button>
  );
};
